import BookLabTests from './BookLabTest';

export default BookLabTests;
